import qs from 'qs'

import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`

interface SearchUsersProps {
  keyword: string
  startCreatedDate: string
  endCreatedDate: string
  startModifiedDate: string
  endModifiedDate: string
  page: number
  size: number
  roleName: string
  sort: string
  pageable: object
}

interface SearchRolesProps {
  keyword: string
  page: number
  size: number
  sort: string
  pageable: object
}

export const searchAllUsers = async (params: SearchUsersProps) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v1/user/search`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const searchAllRoles = async (params: SearchRolesProps) => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v1/role/search`, {
      params,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}
